import styled from "styled-components";
import Avatar from "./avatar/Avatar";

type Props = {
  avatarSrc?: string;
  title: string;
  subline?: string;
  variant?: "s" | "m" | "l" | "xl" | "xxl";
};
const Profile = ({ variant = "m", ...args }: Props) => {
  return (
    <Wrapper variant={variant}>
      <Avatar className="avatar" src={args.avatarSrc} variant={variant} />
      <Information variant={variant}>
        <span>{args.title}</span>
        {args.subline && <span>{args.subline}</span>}
      </Information>
    </Wrapper>
  );
};

type StyledProps = {
  variant: string;
};

const Wrapper = styled.div<StyledProps>`
  display: flex;
  align-items: center;
  .avatar {
    margin-right: var(--nf-spacing-${(props) => props.variant});
  }
`;

const Information = styled.div<StyledProps>`
  overflow: hidden;
  span {
    display: block;
    font-size: var(--nf-font-${(props) => props.variant});
    overflow-wrap: break-word;
  }
  span:first-child {
    text-transform: uppercase;
    color: var(--nf-secondary);
    font-weight: bold;
  }
  span:nth-child(2) {
    color: var(--nf-gray-200);
  }
`;

export default Profile;
